/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Builders_TitleInputs */

const en_directory_hubs_builders_title = /** @type {(inputs: Directory_Hubs_Builders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builders on Seek AI`)
};

const zh_directory_hubs_builders_title = /** @type {(inputs: Directory_Hubs_Builders_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 创作者`)
};

/**
* | output |
* | --- |
* | "Builders on Seek AI" |
*
* @param {Directory_Hubs_Builders_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_builders_title = /** @type {((inputs?: Directory_Hubs_Builders_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Builders_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_builders_title(inputs)
	return zh_directory_hubs_builders_title(inputs)
});
export { directory_hubs_builders_title as "directory.hubs.builders.title" }